"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultObjectValue = exports.useObjectField = void 0;

var _immutable = require("immutable");

var _useFormField = require("./useFormField");

var useObjectField = function useObjectField(state, dispatch) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (args.valueFromChange === undefined) {
    args.valueFromChange = function (v) {
      return v;
    };
  }

  return (0, _useFormField.useFormField)(state, dispatch, args);
};

exports.useObjectField = useObjectField;
var defaultObjectValue = (0, _immutable.Map)();
exports.defaultObjectValue = defaultObjectValue;